<!-- Filter Bar -->
<div class="period-bar">
    <div class="period-buttons">
        <button *ngFor="let p of periods"
                class="period-button"
                [class.active]="selectedPeriod === p.value"
                (click)="onPeriodChange(p.value)">
            {{ p.labelKey | translate }}
        </button>
    </div>

    <div class="custom-dates" *ngIf="showCustomDates">
        <label class="date-label">{{ 'pages.collections.analytics.from' | translate }}</label>
        <input type="date" [(ngModel)]="customFrom" (change)="onCustomDateChange()" class="date-input">
        <label class="date-label">{{ 'pages.collections.analytics.to' | translate }}</label>
        <input type="date" [(ngModel)]="customTo" (change)="onCustomDateChange()" class="date-input">
    </div>

    <mat-form-field class="filter-select" appearance="outline">
        <mat-label>{{ 'pages.collections.analytics.reminder_filter_channels' | translate }}</mat-label>
        <mat-select multiple [value]="selectedChannels" (selectionChange)="onChannelChange($event.value)">
            <mat-option value="email">Email</mat-option>
            <mat-option value="sms">SMS</mat-option>
            <mat-option value="push">Push</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="filter-select" appearance="outline" *ngIf="areas.length > 0">
        <mat-label>{{ 'pages.collections.analytics.filter_area' | translate }}</mat-label>
        <mat-select [value]="selectedAreaId" (selectionChange)="onAreaChange($event.value)">
            <mat-option [value]="null">{{ 'pages.collections.analytics.all_areas' | translate }}</mat-option>
            <mat-option *ngFor="let area of areas" [value]="area._id">
                {{ area.name[translate.currentLang] || area.name['fr'] || area.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <label class="compare-toggle">
        <input type="checkbox" [checked]="comparePrevious" (change)="onCompareToggle()">
        {{ 'pages.collections.analytics.compare_previous' | translate }}
    </label>
</div>

<!-- Loading State -->
<div *ngIf="loading" class="loading-state">
    <mat-spinner diameter="40"></mat-spinner>
    <p>{{ 'pages.collections.analytics.loading' | translate }}</p>
</div>

<!-- Error State -->
<div *ngIf="error && !loading" class="error-state">
    <mat-icon>error_outline</mat-icon>
    <p>{{ 'pages.collections.analytics.error' | translate }}</p>
    <button class="retry-button" (click)="retry()">{{ 'pages.collections.analytics.retry' | translate }}</button>
</div>

<!-- Dashboard Content -->
<div *ngIf="!loading && !error && snapshot" class="dashboard-content">
    <app-reminder-kpi-cards
        [snapshot]="snapshot"
        [comparePrevious]="comparePrevious">
    </app-reminder-kpi-cards>

    <!-- Row 1: Channel + Status -->
    <div class="charts-row-2col">
        <app-reminder-channel-chart
            [data]="distribution?.byChannel || []">
        </app-reminder-channel-chart>

        <app-reminder-status-chart
            [data]="distribution?.byStatus || []">
        </app-reminder-status-chart>
    </div>

    <!-- Row 2: Collection Type + Area -->
    <div class="charts-row-2col">
        <app-reminder-collection-type-chart
            [data]="distribution?.byCollectionType || []">
        </app-reminder-collection-type-chart>

        <app-reminder-area-chart
            [data]="distribution?.byArea || []">
        </app-reminder-area-chart>
    </div>

    <!-- Row 3: Volume trend + Delivery rate trend -->
    <div class="charts-row-2col">
        <app-reminder-volume-trend
            [currentData]="trends?.volume?.current || []"
            [previousData]="trends?.volume?.previous">
        </app-reminder-volume-trend>

        <app-reminder-delivery-rate-trend
            [currentData]="trends?.deliveryRate?.current || []"
            [previousData]="trends?.deliveryRate?.previous">
        </app-reminder-delivery-rate-trend>
    </div>
</div>
